import type { PropertySchema, ServicesShapesContext } from '@takeshape/schema';
import { getRef, isObjectSchema, refItemToShapeSchema } from '@takeshape/schema';

type ImageShapeMatcher = {
  sourceProperties: string[];
  regex: RegExp;
};

const matchers: ImageShapeMatcher[] = [
  {
    sourceProperties: ['url', 'src'],
    regex: /Image$/
  },
  {
    sourceProperties: ['path'],
    regex: /^Asset$/
  }
];

export function isImageSchema(context: ServicesShapesContext, schema?: PropertySchema): boolean {
  if (!schema) {
    return false;
  }

  // unwrap unnecessary oneOf
  if (schema.oneOf?.length === 1) {
    schema = schema.oneOf[0];
  }

  const ref = getRef(context, schema);
  if (ref) {
    // Shape name must include a keyword
    const matcher = matchers.find((matcher) => matcher.regex.exec(ref.shapeName));
    if (matcher) {
      const schema = refItemToShapeSchema(context, ref);
      if (schema && isObjectSchema(schema)) {
        const { properties } = schema;
        // and have a source property
        return matcher.sourceProperties.some((propName) => {
          const prop = properties[propName];
          return prop?.type === 'string' || prop?.['@tag'] === 'URL';
        });
      }
    }
  }

  return false;
}
